import axios from 'axios';

// Get API base URL from environment variable
// In production (Cloudflare Pages): Set REACT_APP_API_URL to Railway backend URL
// In development: Leave empty to use proxy from package.json (http://localhost:7100)
// NOTE: Create React App uses process.env.REACT_APP_*, NOT import.meta.env (that's for Vite)
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to include auth token if available
api.interceptors.request.use(
  (config) => {
    // Bug 2 Fix: Don't overwrite Authorization header if it's already set
    // (e.g., when admin pages explicitly pass admin_token in headers)
    if (config.headers.Authorization) {
      return config;
    }

    // Bug 1 Fix: Check if this is an admin route and use admin_token if available
    // Determine if this is an admin route by checking the URL path
    const isAdminRoute = config.url?.startsWith('/api/admin') || 
                         (typeof window !== 'undefined' && window.location.pathname.startsWith('/admin'));
    
    if (isAdminRoute) {
      const adminToken = localStorage.getItem('admin_token');
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      }
    } else {
      // For customer routes, use regular token
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - determine if this is admin or customer route
      const isAdminRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');
      
      if (isAdminRoute) {
        // Clear admin tokens and redirect to admin login
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        window.location.href = '/admin/login';
      } else {
        // Clear customer tokens and redirect to customer login
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;